import moment from 'moment';
import { getAuth, signOut } from "firebase/auth";
import { signOutAuth, updateOrdersList } from "@src/app/actions/userActions";

export const getFormattedDate = (date: Date): string => {
    if (!date) {
        return '';
    }
    return moment(date)?.local()?.format('DD MMM, YYYY h:mm a');
};

export const formatPrintAmount = (value: unknown, decimals = 2): string => {
    const num = Number(value);
    if (!Number.isFinite(num)) {
        return '';
    }
    return num.toFixed(decimals);
};

export const migrateOldCartData = async (selectedRestaurant: any) => {
    var t2: any = {};
    var cartDataTemp = JSON.parse(localStorage.getItem(`cartData`) ?? '{}');

    if (selectedRestaurant?.tabs) {
        Object.entries(selectedRestaurant?.tabs).forEach(([key, val]: any) => {
            if (!!+val) {
                new Array(+val).fill('1').forEach((val1: any, val2: any) => {
                    var t1 = cartDataTemp[`${key}-${val2 + 1}`];
                    if (t1) {
                        t2[`${key}-${val2 + 1}`] = t1;
                        delete cartDataTemp[`${key}-${val2 + 1}`];
                    } else if (`${key}-${val2 + 1}` in cartDataTemp) {
                        delete cartDataTemp[`${key}-${val2 + 1}`];
                    }
                });
            }
        });
    }
    if (t2 && Object.keys(t2).length) {
        cartDataTemp[selectedRestaurant?.docId] = t2;
        localStorage.setItem('cartData', JSON.stringify(cartDataTemp));
    }
}

// Utility function to run once per device
export const runOncePerDevice = (envFlag: string, callback: () => void) => {
    if (envFlag !== localStorage.getItem('REACT_APP_FORCE_ACTIONS')) {
        callback();
        localStorage.setItem("REACT_APP_FORCE_ACTIONS", envFlag);
    }
};

export const hasPermission = (
    userPermissions: Record<string, Record<string, boolean>>,
    feature: string,
    action: string
): boolean => {
    return userPermissions[feature]?.[action] ?? false;
};

export const getAnalyticsReport = (_reports: any) => {
    // console.log('getAnalyticsReport', reports);
    // let mapData = {};
    // let salesData = {
    //     weekly: [
    //         { name: 'Mon', food: 24000, room: 12400 },
    //     ],
    //     monthly: [
    //         { name: 'Jan', food: 24000, room: 12400 },
    //     ],
    // };
    // let popularItems = [
    //     { name: 'Margherita Pizza', orders: 1234, growth: '+12%' },
    // ];
    // for(let report of reports) {
        // console.log('report', report);
        // mapData[createdAt] = report
    // }
}
export const clearCacheData = (dispatch: any, navigate: any) => {
    try{
        const auth = getAuth();
        signOut(auth).then(() => {
            caches.keys().then(names => names.forEach(name => caches.delete(name)));
            localStorage.clear();
            sessionStorage.clear();
            indexedDB.databases().then(dbs => dbs.forEach((db: any) => indexedDB.deleteDatabase(db)));
            document.cookie.split(";").forEach(cookie => {
                document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
            });
            console.clear();
        })
        .then(() => {
            dispatch(signOutAuth({}));
            dispatch(updateOrdersList({}));
        })
        .then(() => {
            navigate('/login');
        });
    } catch (e) {
        console.error('Error in clearing cache', e);
    }
};

// Example: "AB1234"
export const generateOrderId = (digit: number = 6): string => {
    if (digit < 2) throw new Error("Digit must be at least 2 to include letters.");

    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    
    let orderId = '';

    // Add first 2 letters
    for (let i = 0; i < 2; i++) {
        orderId += letters.charAt(Math.floor(Math.random() * letters.length));
    }

    // Add remaining numeric characters
    for (let i = 2; i < digit; i++) {
        orderId += numbers.charAt(Math.floor(Math.random() * numbers.length));
    }

    return orderId;
};

// 4 characters, e.g., "B7M2"
export const generateUniqueCode = (digit: number = 8): string => {
    // const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const chars = '0123456789';
    let orderId = '';

    for (let i = 0; i < digit; i++) {
        orderId += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return orderId;
};

export const getRoomLabelText = (key: string, value: number): string => {
    const fallbackLabel = `${key}_${value}`;

    if (!key || value === null || value === undefined) {
        return fallbackLabel;
    }

    const keyMatch = key.match(/^(.*?)(?:_(\d+))?$/);
    if (!keyMatch || !keyMatch[1]) {
        return fallbackLabel;
    }

    const baseKey = keyMatch[1];
    const keySuffixNumber = keyMatch[2];

    if (keySuffixNumber !== undefined) {
        const suffixAsNumber = Number(keySuffixNumber);
        if (!Number.isFinite(suffixAsNumber)) {
            return fallbackLabel;
        }
        // e.g. table_10 + 1 → 10*10+1 = 101 (table_101); ROOM_30 + 1 → 30*10+1 = 301 (ROOM_301)
        const combined = suffixAsNumber * 10 + value;
        return `${baseKey}_${combined}`;
    }

    return `${baseKey}_${value}`;
};

